import {
  SIGN_IN,
  SIGN_IN_SUCCESS,
  SIGN_IN_FAILED,
  ADD_ACCOUNT,
  ADD_ACCOUNT_SUCCESS,
  ADD_ACCOUNT_FAILED,
  ADD_ROLED_USER,
  EDIT_USER_INFO,
  ADD_ROLED_USER_SUCCESS,
  ADD_ROLED_USER_FAILED,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILED,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILED,
  SIGNED_OUT,
  FETCH_FORGOT_PASSWORD,
  FETCH_FORGOT_PASSWORD_FAILED,
  FETCH_FORGOT_PASSWORD_SUCCESS,
  FETCH_USERS,
  FETCH_USERS_SUCCES,
  FETCH_USERS_FAILED,
  CHECK_EMAIL,
  CHECK_EMAIL_FAILED,
  CHECK_EMAIL_SUCCESS,
  SEND_EMAIL,
  SEND_EMAIL_FAILED,
  SEND_EMAIL_SUCCES,
  UPDATE_ROLE,
  UPDATE_ROLE_SUCCES,
  UPDATE_ROLE_FAILED
} from "./constants";

const initialState = {
  user: null,
  isAdmin: false,
  isTest: false,
  isTestLoaded: false,
  isAdminLoaded: false,
  isLoadingForgotPassword: false,
  hasFilledTa: false,
  hasFilled12: false,
  hasFilled24: false,
  name: "",
  role_add: "ta",
  password: "",
  email: "",
  userExist: ""
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case FETCH_USERS:
      return {
        ...state,
        loading: true
      };

    case DELETE_USER:
      return { ...state };

    case DELETE_USER_SUCCESS:
      return { ...state };

    case DELETE_USER_FAILED:
      return { ...state };

    case FETCH_USERS_SUCCES:
      return {
        ...state,
        users: action.payload.data,
        loading: false
      };

    case EDIT_USER_INFO:
      return {
        ...state,
        ...action.payload.data
      };

    case FETCH_USERS_FAILED:
      return {
        ...state,
        error: true,
        errorMessage: action.payload.message,
        loading: false
      };

    case UPDATE_ROLE:
      return { ...state, ...action.payload.data };
    case UPDATE_ROLE_FAILED:
      return { ...state, ...action.payload.data };
    case UPDATE_ROLE_SUCCES:
      return { ...state, ...action.payload.data };

    case SEND_EMAIL:
      return {
        ...state
      };
    case SEND_EMAIL_SUCCES:
      return { ...state };

    case SEND_EMAIL_FAILED:
      return { ...state };

    case CHECK_EMAIL:
      return {
        ...state
      };

    case CHECK_EMAIL_FAILED:
      return {
        ...state,
        userExist: ""
      };

    case CHECK_EMAIL_SUCCESS:
      return {
        ...state,
        userExist: action.payload.message[0]
          ? "Email eksistere allerede"
          : "existsnot"
      };

    case ADD_ROLED_USER:
      return {
        ...state,
        addingPost: true
      };
    case ADD_ROLED_USER_SUCCESS:
      return {
        ...state,
        data: action.payload.data
      };
    case ADD_ROLED_USER_FAILED:
      return {
        ...state,
        errorMessage: action.payload.message
      };

    case ADD_ACCOUNT:
      return {
        ...state,
        submitting: true
      };
    case ADD_ACCOUNT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        submitting: false,
        error: null
      };
    case ADD_ACCOUNT_FAILED:
      return {
        ...state,
        submitting: false,
        error: action.payload.data.message
      };
    case SIGN_IN:
      return {
        ...state,
        submitting: true
      };
    case SIGN_IN_SUCCESS:
      return {
        ...state,
        submitting: false,
        error: null,
        user: action.payload.user,
        signInType: action.payload.type
      };
    case SIGN_IN_FAILED:
      return {
        ...state,
        submitting: false,
        error: action.payload.data.message
      };
    case SIGNED_OUT:
      return {
        ...state,
        user: null
      };
    case FETCH_USER_SUCCESS:
      return {
        ...state,
        role: action.payload.userData.role,
        isAdminLoaded: true,
        isTestLoaded: true
      };
    case FETCH_USER_FAILED:
      return {
        ...state,
        isAdminLoaded: true,
        isTestLoaded: true
      };
    case FETCH_FORGOT_PASSWORD:
      return {
        ...state,
        isLoadingForgotPassword: true
      };
    case FETCH_FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoadingForgotPassword: false,
        resetSuccess: true
      };
    case FETCH_FORGOT_PASSWORD_FAILED:
      return {
        ...state,
        isLoadingForgotPassword: false,
        error: action.payload.data.message
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/reducer.js